export default {
    EXACT_URL: 'Exact URL',
    PATH_URL: 'Path URL*',
    ROOT_DOMAIN: 'Root domain',
    SUBDOMAIN: 'Subdomain',
};
